import {
  
    FileDownloadOutlined,
  } from "@mui/icons-material";
  import { IconButton, Tooltip } from "@mui/material";
  import React from "react";
  import { Controller, useForm } from "react-hook-form";
  
  import AppConfirmDialog from "components/Shared/AppConfirmDialog";
  import DateRangeToggle from "components/Shared/DateRangeToggle";
//   import { useAuth } from "hooks";
  import { exportExcelFile } from "utils/exportExcelFile";
import { useLazyListWarehousesQuery } from "store/services/warehouseApi";
import moment from "moment";
import { toast } from "react-toastify";
  
  const EXCEL_DATA_INITIAL_STATE = { dateRange: [], warehouse_id: null };
  
  const ExportWarehouseExcel = ({ isBusy = false }) => {
    const [showDialog, setShowDialog] = React.useState(false);
    // const [showForm, setShowForm] = React.useState(false);
    // const { viewEntity } = useAuth();
  
    const { control, handleSubmit, reset } = useForm({
      defaultValues: EXCEL_DATA_INITIAL_STATE,
    });
  
    const [fetchWarehouses] = useLazyListWarehousesQuery();
   
  
    
      
  
    const handleDownload = async (data) => {
      const { dateRange } = data;
  
      // Format dates using moment to handle both predefined and custom ranges
      const fromDate = moment(dateRange[0]).format("MM-DD-YYYY");
      const toDate = moment(dateRange[1]).format("MM-DD-YYYY");
  
      const payload = {
          fromDate,
          toDate,
      };
  
      try {
          const responseDate = await fetchWarehouses(payload).unwrap();
          if (!responseDate.data || responseDate.data.length === 0) 
            toast.error("No Data Found!");
  
          const formattedData = responseDate.data.map((row, index) => ({
         
          SN: index + 1,
          "Warehouse ID": row.warehouse_id || "N/A",
          "Name": row.name || "N/A",
          "Location": row.location ? `${row.location.lat}, ${row.location.lon}` : "N/A",
          "Contact": row.contact_details || "N/A",
          "Capacity": row.capacity || "N/A",
        }));
  
        exportExcelFile({ 
          sheetData: formattedData, 
          fileName: `Warehouses${formattedData?.warehouse_id || 'All'}_${new Date().toISOString().slice(0, 10)}.xlsx`
        });
      } catch (error) {
        console.error("Export failed:", error);
      } finally {
        handleReset();
      }
    };
  
    const handleReset = () => {
      setShowDialog(false);
      reset(EXCEL_DATA_INITIAL_STATE);
    };
  
    return (
      <>
        <Tooltip title="Download Excel" arrow>
          <IconButton color="success" onClick={() => setShowDialog(true)}>
            <FileDownloadOutlined />
          </IconButton>
        </Tooltip>
  
        <AppConfirmDialog
          open={showDialog}
          onClose={handleReset}
          onConfirm={handleSubmit(handleDownload)}
          title="Download Warehouses"
          dialogIcon={() => <FileDownloadOutlined color="success" />}
        >
           
          <Controller
            name="dateRange"
            control={control}
            rules={{ required: "Date range is required" }}
            render={({ field, fieldState: { error } }) => (
              <DateRangeToggle
                {...field}
                label="Select Date Range"
                error={!!error}
                helperText={error?.message}
                required
              />
            )}
          />
        </AppConfirmDialog>
      </>
    );
  };
  
  export default ExportWarehouseExcel;